import styled from 'styled-components'

export const SortFieldWrapper = styled.div`
  cursor: pointer;
  user-select: none;
  .ant-table-column-sorter {
    font-size: 1rem;
  }
`
